<template>
  <div class="main-navbar__search d-none d-md-flex d-lg-flex">
    <d-input-group class="ml-3" seamless>
      <d-input-group-text slot="prepend">
        <i class="material-icons">search</i>
      </d-input-group-text>
      <d-input v-model="searchInput" @focusin.native="inputFocused = true" @focusout.native="inputFocused = false" @keyup.enter.native="enterPressed" class="navbar-search" :placeholder="$t('editor.globalSearch')"/>
      <d-input-group-text slot="append" >
        <span v-if="searchInput && inputFocused">{{ $t('editor.pressEnter') }}</span>
      </d-input-group-text>
    </d-input-group>
  </div>
</template>
<script>
export default {
  name: 'NavbarSearch',
  data() {
    return {
      searchInput: '',
      inputFocused: false,
    };
  },
  methods: {
    enterPressed() {
      if (this.inputFocused && this.searchInput) {
        this.$router.push({ name: 'member-search', params: { searchQuery: encodeURI(this.searchInput) } });
      }
    },
  },
};
</script>

<style scoped>
.navbar-search {
  padding-right: 85px;
}
</style>
